import React, { useEffect, useState, useRef } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import FormikForm from "components/shared/FormikForm";
import { useDispatch } from "react-redux";
import { addEnergyPackageApi, editEnergyPackageApi } from "store/actions";
import Validation from "views/energyPackages/Validation";

export default function AUEnergyPackageModal({
  show,
  handleClose,
  rowData,
  loading
}) {
  const dispatch = useDispatch();
  const refForm = useRef();
  const InputFields = [
    {
      name: "name",
      type: "text",
      label: "Name",
      placeholder: "Enter Name...",
    },
    {
      name: "logo",
      type: "image",
      label: "Logo",
      placeholder: "Logo...",
    },
    {
      name: "energy",
      type: "number",
      label: "Energy",
      placeholder: "Energy...",
      min: 1,
      max: 5000
    }, ,
    {
      name: "price",
      type: "number",
      label: "Price",
      placeholder: "Price...",
    },
    {
      name: "discountPercent",
      type: "number",
      label: "Discount Percent",
      placeholder: "Discount Percent...",
      min: 0,
      max: 99
    },
    {
      name: "discountedPrice",
      type: "number",
      label: "Discounted Price",
      placeholder: "Discounted Price...",
      selectDisable: true
    },
    {
      name: "gelPrice",
      type: "number",
      label: "Fiat Price",
      placeholder: "Fiat Price..."
    },
    // {
    //   name: "isHotOffer",
    //   type: "checkbox",
    //   label: "Hot Offer",
    //   placeholder: "Hot Offer...",
    // },
  ];

  useEffect(() => {

    if (rowData?._id && refForm.current) {
      refForm.current.setValues({
        name: rowData?.name || "",
        logo: rowData?.logo || "",
        energy: rowData?.energy || 0,
        price: rowData?.price || 0,
        currency: rowData?.currency || "Tether",
        currencySymbol: rowData?.currencySymbol || "usdt",
        currencyIcon: rowData?.currencyIcon || "https://sound.bitanicagames.com/usdt.png",
        status: rowData?.status || "active",
        // isHotOffer: rowData?.isHotOffer,
        discountPercent: rowData?.discountPercent || 0,
        discountedPrice: rowData?.discountedPrice || 0,
        gelPrice: rowData?.gelPrice
      })
    }
  }, [rowData]);

  const [initialValues, setInitalValues] = useState({
    name: "",
    logo: "",
    price: 0,
    energy: 0,
    discountPercent: 0,
    discountedPrice: 0,
    currency: "Tether",
    currencySymbol: "usdt",
    currencyIcon: "https://sound.bitancagames.com/usdt.png",
    status: "active",
    gelPrice: 0
    // isHotOffer: false,
  });

  const [inputFields, setInputFields] = useState(InputFields);

  const handleValuesChange = (newValues) => {
    const { price, discountPercent } = newValues;

    if (price >= 0 && discountPercent >= 0 && discountPercent <= 99) {
      const discountedPrice = +(price - (price * discountPercent) / 100).toFixed(2);

      if (refForm.current) {
        refForm.current.setFieldValue('discountedPrice', discountedPrice);
      }

      setInitalValues({
        ...newValues,
        discountedPrice,
      });
    } else {
      setInitalValues(newValues);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
      size="lg"
    >
      <Modal.Header className="py-3 text-dark" closeButton>
        <Modal.Title className="fw-bold text-dark">{rowData ? "Update" : "Add"} Energy Package</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <FormikForm
            initialValues={initialValues}
            validationSchema={Validation}
            onSubmit={(values, { setSubmitting }) => {
              // console.info("onSubmit call", values)
              if (rowData?._id) {
                dispatch(editEnergyPackageApi({
                  data: { ...values , _id: rowData?._id }, callback: (err, res) => {
                    if (err) return;
                    handleClose();
                  }
                }));
              } else {
                dispatch(addEnergyPackageApi({
                  data: values, callback: (err, res) => {
                    if (err) return;
                    handleClose();
                  }
                }));
              }
            }}
            loading={loading}
            inputFields={inputFields}
            buttonText={"Submit"}
            col={6}
            ref={refForm}
            onValuesChange={handleValuesChange}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
}